<template>
  <div class="aPullc" @click="toApp()">
    <img src="./images/bg.png" alt="" />
  </div>
</template>
<script>
import i18n from '@/locales/index'
export default {
  name: 'UserRelation',
  props: {},
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {
    toApp() {
      this.$confirm({
        content: i18n.t('upgrade_page_views_apullc_index_1958'),
        title: i18n.t('upgrade_page_views_order_confirm_order_291'),
        showCancelButton: false,
        confirmButtonText: i18n.t('upgrade_page_layout_header_41'),
        closeOnClickModal: false
      }).then(() => {
        try {
          const url =
            this.$util.nativeType === 'iOS'
              ? 'h5invokeapp:///aPullc'
              : 'nicee://main/?aPullc';
          window.location.href = url;
        } catch (error) {
          this.$util.jumpAppStore();
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.aPullc {
  width: 100%;
  display: flex;
  justify-content: center;
  img {
    // width: 100%;
    max-width: 100%;
    height: auto;
  }
}
</style>
